import { render, staticRenderFns } from "./Antea.vue?vue&type=template&id=039f0383"
import script from "./Antea.vue?vue&type=script&lang=js"
export * from "./Antea.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports